import React, { useEffect, useState } from "react";
import "./App.css";

import ReloadSpinner from "./components/spinner";
import BackgroundChanger from "./components/backgroundChanger";

import LetterGridPage from "./components/background/letters";
import './components/background/letters.css';

const adjectives = [
  "kind", "brave", "cheerful", "wise", "friendly",
  "gentle", "loyal", "gracious", "joyful", "humble",
  "witty", "calm", "hopeful", "generous", "creative",
  "honest", "sincere", "patient", "thoughtful", "radiant",
  
  // Extra positive traits
  "ambitious", "charming", "diligent", "elegant", "fearless",
  "grateful", "inspired", "intrepid", "jovial", "kindhearted",
  "luminous", "mindful", "noble", "optimistic", "passionate",
  "resilient", "spirited", "tolerant", "upbeat", "vibrant",
  
  // More adjectives for character & vibe
  "adventurous", "bold", "brilliant", "courageous", "dependable",
  "empathetic", "fearless", "gentle", "honorable", "imaginative",
  "joyous", "knowledgeable", "loving", "motivated", "nurturing",
  "peaceful", "quirky", "reliable", "strong", "trustworthy"
];

const names = [
  // Scientists & Inventors
  { id: "einstein", wiki: "Albert_Einstein" },
  { id: "curie", wiki: "Marie_Curie" },
  { id: "darwin", wiki: "Charles_Darwin" },
  { id: "newton", wiki: "Isaac_Newton" },
  { id: "hawking", wiki: "Stephen_Hawking" },
  { id: "galileo", wiki: "Galileo_Galilei" },
  { id: "edison", wiki: "Thomas_Edison" },
  { id: "franklin", wiki: "Benjamin_Franklin" },
  { id: "feynman", wiki: "Richard_Feynman" },

  // Artists & Creatives
  { id: "daVinci", wiki: "Leonardo_da_Vinci" },
  { id: "vangogh", wiki: "Vincent_van_Gogh" },
  { id: "picasso", wiki: "Pablo_Picasso" },
  { id: "michelangelo", wiki: "Michelangelo" },
  { id: "banksy", wiki: "Banksy" },
  { id: "warhol", wiki: "Andy_Warhol" },
  { id: "rembrandt", wiki: "Rembrandt" },
  { id: "dali", wiki: "Salvador_Dalí" },
  { id: "miyazaki", wiki: "Hayao_Miyazaki" },

  // Musicians & Performers
  { id: "freddie", wiki: "Freddie_Mercury" },
  { id: "elvis", wiki: "Elvis_Presley" },
  { id: "beyonce", wiki: "Beyoncé" },
  { id: "rihanna", wiki: "Rihanna" },
  { id: "madonna", wiki: "Madonna_(entertainer)" },
  { id: "adele", wiki: "Adele" },
  { id: "elton", wiki: "Elton_John" },
  { id: "marley", wiki: "Bob_Marley" },
  { id: "shakira", wiki: "Shakira" },
  { id: "mozart", wiki: "Wolfgang_Amadeus_Mozart" },
  { id: "beethoven", wiki: "Ludwig_van_Beethoven" },

  // Actors & Filmmakers
  { id: "chaplin", wiki: "Charlie_Chaplin" },
  { id: "hitchcock", wiki: "Alfred_Hitchcock" },
  { id: "keanu", wiki: "Keanu_Reeves" },

  // Athletes
  { id: "serena", wiki: "Serena_Williams" },
  { id: "kobe", wiki: "Kobe_Bryant" },
  { id: "messi", wiki: "Lionel_Messi" },
  { id: "pele", wiki: "Pelé" },
  { id: "bolt", wiki: "Usain_Bolt" },
  { id: "ali", wiki: "Muhammad_Ali" },
  { id: "ronaldo", wiki: "Cristiano_Ronaldo" },
  { id: "federer", wiki: "Roger_Federer" },

  // Writers & Storytellers
  { id: "tolkien", wiki: "J._R._R._Tolkien" },
  { id: "rowling", wiki: "J._K._Rowling" },
  { id: "shakespeare", wiki: "William_Shakespeare" },
  { id: "dahl", wiki: "Roald_Dahl" },
  { id: "miyamoto", wiki: "Shigeru_Miyamoto" },
  { id: "lucas", wiki: "George_Lucas" },
  { id: "spielberg", wiki: "Steven_Spielberg" },
  { id: "nolan", wiki: "Christopher_Nolan" },
  { id: "morgan", wiki: "Morgan_Freeman" },

  // Humanitarians & Icons
  { id: "hepburn", wiki: "Audrey_Hepburn" },
  { id: "angelina", wiki: "Angelina_Jolie" },
  { id: "theresa", wiki: "Mother_Teresa" },
  { id: "gandhi", wiki: "Mahatma_Gandhi" },

  // Pop Culture / Other Icons
  { id: "yoda", wiki: "Yoda" },
  { id: "batman", wiki: "Batman" },
  { id: "pikachu", wiki: "Pikachu" },
  { id: "totoro", wiki: "Totoro" },
  { id: "spock", wiki: "Spock" },
  { id: "groot", wiki: "Groot" },
  { id: "snoopy", wiki: "Snoopy" },
  { id: "mario", wiki: "Mario" },
  { id: "zelda", wiki: "Princess_Zelda" },
  { id: "kermit", wiki: "Kermit_the_Frog" }
];

const stylesTexte = [
  // 1. Windows 95
  {
    background: "#C0C0C080",
    color: "black",
    fontFamily: "Tahoma, sans-serif",
    padding: "20px",
    border: "2px solid #808080",
    boxShadow: "inset -2px -2px 0 #fff, inset 2px 2px 0 #000",
  },
  // 2. Windows XP
  {
    background: "#00309C80",
    color: "#FFFFFF80",
    fontFamily: "Verdana",
    padding: "20px",
    borderRadius: "6px",
  },
  // 3. Windows Vista
  {
    background: "linear-gradient(to bottom, #1C1C1C80, #4F4F4F80)",
    color: "#00B7FF",
    fontFamily: "Segoe UI",
    padding: "20px",
    borderRadius: "12px",
  },
  // 4. Atari 2600
  {
    background: "#00000080",
    color: "#FF002B",
    fontFamily: "'Press Start 2P', monospace",
    padding: "20px",
    letterSpacing: "3px",
  },
  // 5. Atari ST
  {
    background: "#C8C8C880",
    color: "black",
    fontFamily: "Geneva, sans-serif",
    padding: "20px",
    border: "1px solid black",
  },
  // 6. PlayStation 1
  {
    background: "#D6D6D680",
    color: "#003087",
    fontFamily: "'Courier New', monospace",
    padding: "20px",
    textTransform: "uppercase",
  },
  // 7. PlayStation 2
  {
    background: "#00000080",
    color: "#00A2FF",
    fontFamily: "Arial Black",
    padding: "20px",
    letterSpacing: "2px",
  },
  // 8. PlayStation 3
  {
    background: "#18181880",
    color: "white",
    fontFamily: "'Futura', sans-serif",
    padding: "20px",
    textShadow: "0 0 8px #fff",
  },
  // 9. Mac OS Classic
  {
    background: "#EDEDED80",
    color: "black",
    fontFamily: "'Chicago', sans-serif",
    padding: "20px",
    border: "2px solid #A0A0A0",
  },
  // 10. Mac OS X Aqua
  {
    background: "linear-gradient(to bottom, #A8D0FF80, #4B8BFF80)",
    color: "#FFFFFF80",
    fontFamily: "Lucida Grande",
    padding: "20px",
    borderRadius: "20px",
  },
  // 11. Game Boy
  {
    background: "#9BBC0F80",
    color: "#0F380F",
    fontFamily: "'Press Start 2P'",
    padding: "20px",
  },
  // 12. NES
  {
    background: "#00000080",
    color: "#FF0000",
    fontFamily: "'Press Start 2P'",
    padding: "20px",
  },
  // 13. SNES
  {
    background: "#B5B5B580",
    color: "#4a4a4a",
    fontFamily: "Arial",
    padding: "20px",
    borderRadius: "8px",
  },
  // 14. Sega Genesis
  {
    background: "#00000080",
    color: "#00AAFF",
    fontFamily: "'Eurostile', sans-serif",
    padding: "20px",
  },
  // 15. Sega Dreamcast
  {
    background: "#FFFFFF80",
    color: "#FF6600",
    fontFamily: "'Trebuchet MS'",
    padding: "20px",
  },
  // 16. Commodore 64
  {
    background: "#40318D80",
    color: "#A6A56C",
    fontFamily: "'C64 Pro', monospace",
    padding: "20px",
  },
  // 17. MS-DOS
  {
    background: "#00000080",
    color: "#00FF00",
    fontFamily: "'Courier New'",
    padding: "20px",
  },
  // 18. Windows 11
  {
    background: "linear-gradient(135deg, #1A73E880, #4E8BF580)",
    color: "#FFFFFF80",
    fontFamily: "Segoe UI Variable",
    padding: "20px",
    borderRadius: "16px",
  },
  // 19. Xbox (OG)
  {
    background: "#00000080",
    color: "#8CC63F",
    fontFamily: "Impact",
    padding: "20px",
  },
  // 20. Nintendo Switch
  {
    background: "#E6001280",
    color: "white",
    fontFamily: "'Montserrat', sans-serif",
    padding: "20px",
    borderRadius: "10px",
  },
];//TODO : add opacity

function getRandomName() {
  const adjective = adjectives[Math.floor(Math.random() * adjectives.length)];
  const nameObj = names[Math.floor(Math.random() * names.length)];
  return {
    id: `${String(adjective).toLowerCase()}_${String(nameObj.id).toLowerCase()}`,
    adjective,
    name: nameObj.id,
    wiki: nameObj.wiki
  };
}

function App() {
  const [cuteName, setCuteName] = useState(getRandomName());
  const [indexStyle, setIndexStyle] = useState(0);
  const [currentBG, setCurrentBG] = useState(0);
  const handleClick = () => {
    setCuteName(getRandomName());
    setIndexStyle((indexStyle + 1) % stylesTexte.length)
  };

  const openWiki = () => {
    const url = `https://en.wikipedia.org/wiki/${cuteName.wiki}`;
    setCurrentBG((currentBG + 1)%250);
    window.open(url, "_blank");
  };

  const handleClickToBattleSheep = () => {
    window.location.href = "https://litespillet.ovh/hexagons/";
  }

  const handleClickToSNWG = () => {
    window.location.href = "https://litespillet.ovh/snwg/";
  }

  return (
    <>
      <div className="page">
        <BackgroundChanger id={currentBG}/>
        <div className="content">
          <button
            onClick={handleClickToBattleSheep}
            style={{
              background: "transparent",
              border: "none",
              width: "100px",    // adjust clickable width
              height: "50px",    // adjust clickable height
              cursor: "pointer",
              position: "fixed", // stick to viewport
              top: 0,
              right: 0,
              zIndex: 1000,      // ensure it's on top
              padding: 0,
              margin: 0,
            }}
          />
          <button
            onClick={handleClickToSNWG}
            style={{
              background: "transparent",
              border: "none",
              width: "100px",    // adjust clickable width
              height: "50px",    // adjust clickable height
              cursor: "pointer",
              position: "fixed", // stick to viewport
              bottom: 0,
              right: 0,
              zIndex: 1000,      // ensure it's on top
              padding: 0,
              margin: 0,
            }}
          />
          <div className="container" style={{textAlign: "center", transition: "all 0.4s ease", ...stylesTexte[indexStyle] }}>
            <div style={{ textAlign: "center" }}>
              You never have nice ideas to name a new stuff. 
              <div/>
              Here is one :
            </div>
            <div className="name-display">
              {String(cuteName.adjective).toLowerCase()}_{String(cuteName.name).toLowerCase()}
            </div>
            <button onClick={handleClick}><ReloadSpinner/></button>
            <button className="wiki-button" onClick={openWiki} title="View on Wikipedia">
              Culture is right this way
            </button>
          </div>
        </div>
      </div>
    </>
  );
}


export default App;
